import { Injectable } from '@angular/core';
import { Watchlist } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class WatchlistService {
	constructor(private http: HttpClient) {}

	public get(): Observable<Watchlist[]> {
		return this.http.get<Watchlist[]>('api/watchlist/get');
	}

	public create(watchlist: Watchlist): Observable<Watchlist> {
		return this.http.post<Watchlist>('api/watchlist/create', watchlist);
	}

	public delete(id: number): Observable<void> {
		return this.http.delete<void>(`api/watchlist/delete/${id}`);
	}
}
